const STORAGE_KEY = 'kora-membership-confirmation'

export interface StoredMembershipConfirmation {
  claimId: string
  token: string
}

/** Move the fragment-only secret out of the address bar before auth initialization. */
export function captureMembershipConfirmationFragment(): void {
  if (window.location.pathname !== '/membership/confirm' || !window.location.hash) return
  const params = new URLSearchParams(window.location.hash.slice(1))
  const claimId = params.get('claim')
  const token = params.get('token')
  try {
    sessionStorage.removeItem(STORAGE_KEY)
    if (claimId && token && /^[A-Za-z0-9_-]{43}$/.test(token)) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ claimId, token }))
    }
  } catch {
    // Private browsing can disable storage; the view will show a missing-link state.
  } finally {
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + window.location.search
    )
  }
}

export function readMembershipConfirmation(): StoredMembershipConfirmation | null {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    if (!stored) return null
    const value: unknown = JSON.parse(stored)
    if (typeof value !== 'object' || value === null || !('claimId' in value) || !('token' in value))
      return null
    if (typeof value.claimId !== 'string' || typeof value.token !== 'string') return null
    return { claimId: value.claimId, token: value.token }
  } catch {
    return null
  }
}

export function clearMembershipConfirmation(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // Storage was unavailable; the in-memory view state is still cleared.
  }
}
